import { ArrowUpRight } from "lucide-react";

const BRAND_STOREFRONTS = [
  {
    brand: "Card Crack Chronicles",
    links: [
      { label: "eBay", href: "https://www.ebay.ca/str/cardcrackchronicles" },
      { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61560254583389" },
    ],
  },
  {
    brand: "The Hammer Haul",
    links: [
      { label: "eBay", href: "https://www.ebay.ca/str/thehammerhaul" },
      { label: "Poshmark", href: "https://poshmark.ca/closet/hammerhaul" },
      { label: "Whatnot", href: "https://www.whatnot.com/s/81W9IkmD" },
      { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61590598823077" },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative bg-[#050505] border-t border-[#262626]"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 pt-20 md:pt-28 pb-10">
        {/* Big wordmark */}
        <div className="flex flex-col gap-2">
          <p className="font-mono-alt text-[11px] tracking-[0.3em] uppercase text-[#c48a64]">
            / 005 — The Dual Hub
          </p>
          <h3 className="font-display text-[16vw] md:text-[11vw] leading-[0.9] font-semibold text-[#f5f5f5] tracking-[-0.03em]">
            Card Crack <span className="text-[#3a3a3a]">+</span> Hammer Haul
          </h3>
        </div>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 border-t border-[#262626] pt-12">
          <div className="md:col-span-4">
            <p className="font-mono-alt text-[11px] tracking-[0.28em] uppercase text-[#6b6b6b] mb-4">
              Location
            </p>
            <p className="text-[#f5f5f5] text-base md:text-lg leading-relaxed max-w-xs">
              Proudly based in <br />
              <span className="text-[#c48a64]">Hamilton, Ontario, Canada.</span>
            </p>

            <p className="mt-10 font-mono-alt text-[11px] tracking-[0.28em] uppercase text-[#6b6b6b] mb-4">
              Sections
            </p>
            <ul className="space-y-3">
              <li>
                <a href="#brands" className="text-[#f5f5f5] copper-underline" data-testid="footer-link-brands">
                  Brands
                </a>
              </li>
              <li>
                <a href="#manifesto" className="text-[#f5f5f5] copper-underline" data-testid="footer-link-shipping">
                  How We Ship
                </a>
              </li>
              <li>
                <a href="#circle" className="text-[#f5f5f5] copper-underline" data-testid="footer-link-circle">
                  Inner Circle
                </a>
              </li>
            </ul>
          </div>

          {BRAND_STOREFRONTS.map((b) => (
            <div key={b.brand} className="md:col-span-4">
              <p className="font-mono-alt text-[11px] tracking-[0.28em] uppercase text-[#6b6b6b] mb-4">
                {b.brand}
              </p>
              <ul className="space-y-3">
                {b.links.map((s) => (
                  <li key={s.label}>
                    <a
                      href={s.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group inline-flex items-center gap-3 text-[#f5f5f5] text-base md:text-lg copper-underline"
                      data-testid={`footer-link-${b.brand.toLowerCase().replace(/\s+/g, "-")}-${s.label.toLowerCase()}`}
                    >
                      {s.label}
                      <ArrowUpRight
                        size={16}
                        className="text-[#c48a64] transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 md:mt-24 pt-8 border-t border-[#262626] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono-alt text-[11px] tracking-[0.24em] uppercase text-[#6b6b6b]">
          <span>© {year} The Dual Hub — All rights reserved.</span>
          <span className="text-[#c48a64]">◆ Curated. Handmade. Shipped.</span>
        </div>
      </div>
    </footer>
  );
}
